import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Form, Col, Row } from 'react-bootstrap';

import Upload from '../../../../components/Input/Upload';
import LayoutContext from '../../../../store/Layout/contexts';
import { newFetch, GET, POST } from '../../../../helpers/fetch';
import Searchbar from '../../../../components/Searchbar';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import AppContext from '../../../../store/App/contexts';
import { config } from '../../../../config/index';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
const { API_URL, SERVER_URL } = config;

const DeliveryOrder = ({ history }) => {
  const type = localStorage.getItem('type');
  const {
    fetchClientsOptions,
    client_options,
    selectedClientID,
    site_options,
    fetchSiteOptions,
    selectedSiteID,
  } = React.useContext(AppContext);
  const [client, setClient] = useState('');
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const siteID = parseInt(localStorage.getItem('site'), 10);
  const [statusOptions, setStatusOptions] = useState([]);
  const [status, setStatus] = useState(0);
  const [associateOptions, setAssociateOptions] = useState([]);
  const [associate, setAssociate] = useState(0);
  const [filteredAssociates, setFilteredAssociates] = useState([]);
  const [catalogues, setCatalogues] = useState([]);

  const [assocCheckedItems, setAssocCheckedItems] = useState([]);
  const [remarks, setRemarks] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [multipleItems, setMultipleItems] = useState([
    {
      id: null,
      item: '',
      quantity: '',
    },
  ]);
  const [site, setSite] = useState('');
  const [origSite, setOrigSite] = useState('');

  const fetchStatusOptions = async () => {
    let api_path = `/fields/delivery_order_status`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatusOptions(response.data);
    }
  };

  const fetchAssociates = async () => {
    let api_path = `/catalogue/client/${clientID}/site/${siteID}/associates`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      setAssociateOptions(response.data);
      setFilteredAssociates(response.data);
    }
  };

  const fetchCatalogue = async () => {
    let api_path = `/catalogue/list`;
    let response = await newFetch(POST, api_path, {
      field: 'name',
      sort: 'ASC',
      page: 0,
      pageSize: 1000,
      client_id: clientID,
    });

    if (response.success) {
      const catalogueData = response.data.list;
      setCatalogues(catalogueData);
    }
  };

  useEffect(() => {
    fetchCatalogue();
    fetchStatusOptions();
    // fetchAssociates();
    fetchClientsOptions(type);
    fetchSiteOptions();
  }, []);

  useEffect(() => {
    fetchAssociates();
  }, [clientID, siteID]);

  useEffect(() => {
    setClient(selectedClientID);
  }, [selectedClientID]);

  useEffect(() => {
    setSite(selectedSiteID);
    fetchAssociates();
  }, [selectedSiteID]);

  const handleDiscard = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setStatus(0);
      setRemarks('');
      setAssocCheckedItems([]);
      setMultipleItems([
        {
          id: null,
          item: '',
          quantity: '',
        },
      ]);
    }
  };

  const validateForm = () => {
    if (!client || client == 0) {
      ToastUtil.error('Please select a Client.');
      return false;
    }

    if (!site || site == 0) {
      ToastUtil.error('Please select a Site.');
      return false;
    }

    if (status === 0) {
      ToastUtil.error('Please select a Status!');
      return false;
    }

    if (assocCheckedItems.length > 1 || assocCheckedItems.length == 0) {
      ToastUtil.error('Please choose one associate.');
      return false;
    }

    const hasValues = multipleItems.every((obj) =>
      ['item', 'quantity'].every(
        (key) => obj[key] !== null && obj[key] !== undefined && obj[key] !== ''
      )
    );

    if (!hasValues) {
      ToastUtil.error('Please select an Item and Quantity!');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        'Are you sure you want to add this Delivery Order?'
      ))
    ) {
      let api_path = `/delivery-order`;
      let response = await newFetch(POST, api_path, {
        status,
        remarks,
        associate: assocCheckedItems,
        items: multipleItems,
        client_id: client,
        site_id: site,
      });

      ToastUtil.success(response.message);

      if (response.success) {
        history.push('/delivery-order');
      }
    }
  };

  const searchHandler = (e) => {
    setSearchValue(e.target.value);

    let filtered = associateOptions.filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    setFilteredAssociates(filtered);
  };

  const checkItem = async (isToggled, id) => {
    let items = [...assocCheckedItems];

    if (isToggled) {
      items = [...items, id];
    } else {
      items = [...items.filter((item) => item !== id)];
    }

    setAssocCheckedItems(items);
  };

  const itemHandler = (e, index) => {
    multipleItems[index].item = e.target.value;
    setMultipleItems([...multipleItems]);
    //setPosition(e.target.value);
  };
  const quantityHandler = (e, index) => {
    const value = e.target.value.replace(/\D/g, '');
    multipleItems[index].quantity = value;
    setMultipleItems([...multipleItems]);
  };

  const addMoreItem = () => {
    multipleItems.push({
      id: null,
      item: '',
      quantity: '',
    });
    setMultipleItems([...multipleItems]);
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to="/delivery-order"
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to Delivery
                  Order
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Add New Delivery Order</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => handleSubmit(e)}>
              <div
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded adjust-shadow">
                  <div
                    className="flex-grow-1 bg-white col-md-12"
                    style={{ padding: '2.25rem' }}
                  >
                    <div className="mb-2">
                      <strong>Client</strong>
                      <p
                        style={{
                          fontSize: 20,
                          color: '#595b5f',
                          fontWeight: 500,
                          paddingLeft: 8,
                        }}
                      >
                        {client_options &&
                          selectedClientID &&
                          client_options.find(
                            (clnt) => clnt.id === parseInt(selectedClientID)
                          )?.name}
                      </p>
                    </div>
                    <div className="mb-2">
                      <strong>Site</strong>
                      <p
                        style={{
                          fontSize: 20,
                          color: '#595b5f',
                          fontWeight: 500,
                          paddingLeft: 8,
                        }}
                      >
                        {site_options &&
                          site_options.find(
                            (siteData) => siteData.id === parseInt(site)
                          )?.name}
                      </p>
                    </div>
                    <div className="row pb-3 col-md-4">
                      <strong>Status</strong>
                      <select
                        name="status"
                        className="form-select mt-3 adjust-fs"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value={0}>Select Status</option>
                        {statusOptions &&
                          statusOptions.map((statusItem, index) => (
                            <option
                              key={`${statusItem.id}_${index}`}
                              value={statusItem.label}
                            >
                              {statusItem.label}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="row pb-3 col-md-12 has-search">
                      <strong>Associate</strong>
                      <div
                        className="position-relative"
                        style={{ paddingLeft: 0 }}
                      >
                        <span
                          className="position-absolute start-0 translate-middle-y ps-2"
                          style={{ color: '#aaa', top: 36 }}
                        >
                          <i className="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control adjust-fs"
                          placeholder={'Search associates'}
                          value={searchValue}
                          style={{
                            paddingLeft: '33px',
                            width: '100%',
                            marginTop: 16,
                          }}
                          onChange={searchHandler}
                        />
                      </div>
                    </div>

                    <div className="d-flex flex-column col-md-12">
                      <div className="row">
                        {filteredAssociates.map((associate, index) => (
                          <div
                            key={index}
                            className="non-team-support col-sm-3 pb-2 d-flex align-items-center justify-content-center"
                          >
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input adjust-fs"
                                type="checkbox"
                                value=""
                                id="assocCheckbox"
                                checked={assocCheckedItems.includes(
                                  associate.id
                                )}
                                onChange={(e) =>
                                  checkItem(e.target.checked, associate.id)
                                }
                              />
                            </div>
                            <div className="">
                              <img
                                className="img-responsive rounded-circle border"
                                style={{ width: '45px', height: '45px' }}
                                src={
                                  associate.image
                                    ? `${SERVER_URL}/${associate.image}`
                                    : placeholderImage
                                }
                                alt="username-img"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = placeholderImage;
                                }}
                              />
                            </div>
                            <div>
                              <p>
                                {associate.last_name_first
                                  ? `${associate.last_name} ${associate.first_name}`
                                  : `${associate.first_name} ${associate.last_name}`}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="pt-4">
                      {multipleItems.length > 0 &&
                        multipleItems.map((item, index) => (
                          <Row className="mb-3" key={index}>
                            <Form.Group as={Col} md="4">
                              <strong>Item</strong>
                              <Form.Control
                                as="select"
                                type="select"
                                name="item"
                                onChange={(e) => itemHandler(e, index)}
                                value={item.item || ''}
                              >
                                <option value="">Select Item</option>
                                {catalogues &&
                                  catalogues.map((positionItem) => (
                                    <option
                                      key={positionItem.id}
                                      value={positionItem.id}
                                    >
                                      {positionItem.name}
                                    </option>
                                  ))}
                              </Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                              <strong>Quantity To Be Delivered</strong>
                              <Form.Control
                                value={item.quantity || ''}
                                placeholder="0"
                                onChange={(e) => quantityHandler(e, index)}
                                maxLength={10}
                              />
                            </Form.Group>
                          </Row>
                        ))}
                      <Row
                        className="mb-3 pt-3"
                        style={{ justifyContent: 'center' }}
                      >
                        <button
                          type="button"
                          className="btn btn-outline-brand ms-3"
                          style={{ width: '9rem' }}
                          onClick={() => addMoreItem()}
                        >
                          Add Item
                        </button>
                      </Row>
                    </div>

                    <div className="row pb-3 col-md-12 pt-3">
                      <strong>Remarks</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3"
                        style={{ resize: 'none' }}
                        placeholder="Remarks"
                        value={remarks}
                        onChange={({ target: { value } }) => setRemarks(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-end"
              >
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={handleDiscard}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(DeliveryOrder);
